import * as React from 'react';

const SpinnerIcon: React.FC = () => (
  <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M29.7728 4.84576C29.6839 4.81898 29.5946 4.7928 29.5051 4.76724C27.7562 4.26756 25.9094 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0456 12.9543 44 24 44C35.0456 44 44 35.0456 44 24C44 22.0086 43.709 20.0853 43.1671 18.2701"
      stroke="#737373"
      strokeWidth="1"
      strokeLinecap="round"
    />
  </svg>
);

export default SpinnerIcon;
